export default {
  // Primary Colors
  madison: '#0D2E68',
  madison_light: '#174BA6',
  assa_blue: '#1749A0',
  blue_zodiac: '#0D2041',

  // Secondary Colors
  bright_turquoise: '#0193E5',
  onahau: '#CEE8FF',
  cloud: '#F5FAFF',

  // Complementary
  white: '#fff',
  gallery: '#EAEAEA',
  silver: '#B8B8B8',
  abbey: '#555659',
  light_silver: '#A3A2A2',

  // Status
  shamrock: '#27AE60',
  bright_pink: '#FF7182',
  lightning_yellow: '#FFB800',

  // Gradients
  cloud_gradient:
    'linear-gradient(180deg, #0D2E68 0%, #123E8A 52.08%, #1E59C0 100%)',
  onahau_gradient: 'linear-gradient(0.16deg, #FFFFFF 13.23%, #CEE8FF 105.34%)',
};
